import { POILimited } from './limited';

export default POILimited;
